export class SideSheetUtils {
  private static readonly _sideSheetWidthPercentages = new Map<string, number>([
    ['vehicles', 40],
    ['users', 40],
    ['asset-type', 40],
    ['expenses-setup', 40],
    ['fuel-prices', 40],
    ['trip-type', 60],
    ['roles', 40],
    ['vehicle-tags', 40],
    ['user-tags', 40],
  ]);

  private static readonly _defaultSideSheetWidthPercentage = 30;

  static getDefaultWidthPercentage(pageName: string): number {
    if (this._sideSheetWidthPercentages.has(pageName)) {
      return this._sideSheetWidthPercentages.get(pageName)!;
    }

    return this._defaultSideSheetWidthPercentage;
  }
}
